// Imports -------------------------------------------------------------------->

import {generateUUID} from "../utils/uuid";

const singletons: any = {};

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

export function service(nameOrCtor?: any): any {
	const isNamed = typeof nameOrCtor === "string";
	const name = isNamed ? nameOrCtor : "";
	const inner = (constructor: any) => {
		if (constructor.__service_name) throw new Error(
				"Attempt to register already registered service.");

		Object.defineProperty(constructor, "__service_name", {
			enumerable: false,
			configurable: false,
			writable: false,
			value: name || generateUUID()
		});
	};

	if (isNamed) {
		return inner;
	} else {
		inner(nameOrCtor);
	}
}

export function getService(name: string) {
	return singletons[name];
}

export function bindService(name: string, impl: any) {
	singletons[name] = impl;
}

export function inject(target: any, key: string): void {
	const type = Reflect.getMetadata("design:type", target, key);
	const serviceName = type.__service_name;
	if (!serviceName) throw new Error(
			`Attempt to inject a non-registered service to ${key}.`);

	Object.defineProperty(target, key, {
		enumerable: true,
		get: function() {
			singletons[serviceName] = singletons[serviceName] || new type();
			return singletons[serviceName];
		}
	});
}

// TODO we should initialize all services before main code will start, current version is initializing service at first appearance of it in @inject // i guess so
export class Service {
	static __service_name: string;

	static getInstance() {
		const serviceName = this.__service_name;
		if (!serviceName) throw new Error(
				`Attempt to get a non-registered service.`);

		singletons[serviceName] = singletons[serviceName] || new this();
		return singletons[serviceName];
	}
}

